'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processAlbums = processAlbums;
exports.getDefaultImageName = getDefaultImageName;

var _datetime = require('helpers/datetime');

var _projects = require('helpers/projects');

function processAlbum(album) {
  album.sender = [album.owFirstname, album.owLastname].join(' ').trim();
  album.albumName = [album.album, album.album2].join(' ').trim();
  album.shortSentDate = (0, _datetime.formatDate)(album.sent_date);
  album.fullSentDate = (0, _datetime.formatDateTime)(album.sent_date);
  return album;
}

function processAlbums(albums) {
  if (Array.isArray(albums)) {
    albums.map(function (album) {
      return processAlbum(album);
    });
  } else {
    processAlbum(albums);
  }

  return albums;
}

function getDefaultImageName(album) {
  return album.projectContentType === _projects.projectTypes.quickSend || album.projectType === _projects.projectTypes.quickSend ? 'no-image-qs' : 'no-image';
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Albums.js
// module id = 525
// module chunks = 1